import PostTable from "../components/PostTable";

export default function PostsPage() {
	return <PostTable />;
}
